// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__XY80W","right":"Layout_right__njhb1","inner":"Layout_inner__NTvfx"};